import HeaderProcess from '../../components/sections/HeaderProcess'
import Steps from '../../components/sections/Steps'
import PartitionBee from '../../components/PartitionBee'
import Packages from '../../components/sections/Packages'
import './process.css'

const Process = () => {
  return (
    <>
    <HeaderProcess />
    <Steps />
    <PartitionBee sectionAbove="celebrancy" skin="light" />
    <Packages />
    </>
  )
}

export default Process